import { appConfig } from 'config'

export const downloadCSVFile = (content: string, fileName: string = 'download'): void => {
  const blob = new Blob(['\uFEFF', content])
  const url = URL.createObjectURL(blob)
  //const dataURI = 'data:text/csv;charset=utf-8,\uFEFF' + encodeURIComponent(content)

  const anchor = document.createElement('a')
  anchor.href = url

  anchor.download = fileName + '.csv'
  anchor.setAttribute('style', 'visibility:hidden')

  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
}

export const downloadUnicodeCSVFile = (content: string, fileName: string = 'download'): void => {
  const dataURI = 'data:text/csv;charset=utf-8,' + encodeURIComponent(content)

  const anchor = document.createElement('a')
  anchor.download = fileName
  anchor.href = dataURI

  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
}

export const csv2json = (str: string, delimiter = ',') => {
  const titles = str.slice(0, str.indexOf('\n')).split(delimiter)
  const rows = str.slice(str.indexOf('\n') + 1).split('\n')
  const data = [] as any[]
  const rowsData = rows.splice(2, appConfig.importProductMaxRecord || 1000)
  rowsData.forEach(row => {
    const values = row.split(delimiter)
    if (values[2] !== '') {
      data.push(titles.reduce((object: any, curr: any, i) => ((object[curr] = values[i]), object), {}))
    }
  })
  return data
}

export default downloadCSVFile
